import { APP_URL, GROUP_PRIZES, SINGLE_PRIZE } from "@/lib/constants";

function prizeBlock(): string {
  const g = GROUP_PRIZES.map(p => p.short).join(" / ");
  return `\n\nGruppenpreise: ${g} Sponsoring\nEinzelpreis: ${SINGLE_PRIZE.title} (${SINGLE_PRIZE.hotel})`;
}

export function appUrl(): string {
  if (typeof window !== "undefined" && window.location?.origin) return window.location.origin;
  return APP_URL;
}

export function buildInviteUrl(code?: string | null): string {
  const base = appUrl();
  return code ? `${base}/?code=${encodeURIComponent(code.toUpperCase())}` : base;
}

export function buildInviteText(opts: { groupName?: string; code?: string | null }): string {
  const url = buildInviteUrl(opts.code);
  const prizes = prizeBlock();
  if (opts.code && opts.groupName) {
    return `⚽ Tritt unserer Englputzeder-WM-Tippgruppe „${opts.groupName}" bei!\n\nCode: ${opts.code}\n${url}${prizes}`;
  }
  if (opts.code) {
    return `⚽ Tippe mit mir die WM 2026 bei Englputzeder!\n\nGruppen-Code: ${opts.code}\n${url}${prizes}`;
  }
  return `⚽ Tippe mit mir die WM 2026 bei Englputzeder!\n\n${url}${prizes}`;
}

export async function shareInvite(text: string, title = "Englputzeder Tippspiel"): Promise<void> {
  const nav = typeof navigator !== "undefined" ? navigator : null;
  if (nav && (nav as any).share) {
    try {
      await (nav as any).share({ title, text });
      return;
    } catch {
      // user cancelled — fall through to WhatsApp
    }
  }
  const wa = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(wa, "_blank", "noopener,noreferrer");
}
